var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"navbar-sidebar"}},[_c('div',{staticClass:"navbar-sidebar__items"},[_c('NavbarNav')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }